import React, { useEffect, useRef } from 'react';
import { Grid } from 'semantic-ui-react';
import { Loading, AccordionWrapper } from 'react-lib/dist/components-es';
import { recordOptionType, entityType } from '@src/constants';
import styles from '../components/styles/Activity.module.scss';
import { useTitleDispatch } from '@components/TitleContextProvider';
import { useTranslation } from 'react-i18next';
import FilteringContextProvider from '@filters/FilteringContextProvider';
import { compose } from 'redux';
import { filterActions } from '@behavior/filter';
import { dataViewActions } from '@behavior/dataview';
import { connect } from 'react-redux';
import FiltersPanel from '@filters/FiltersPanel/FiltersPanel';
import OverviewTable from '@filters/OverviewTable/OverviewTable';
import { Activity } from 'routes';
import ViewOptionsContainer from './ViewOptionsPanel/ViewOptionsContainer';

type Props = {
  history: any;
  tableOptions: string[];
  allFilters: any;
  entityTypeProps: string;
  actions: any;
  defaultFilteredList: any;
};

const ActivityOverviewContainer = ({
  history,
  tableOptions,
  allFilters,
  entityTypeProps,
  actions,
  defaultFilteredList,
}: Props) => {
  const { t } = useTranslation();
  const dispatch = useTitleDispatch();

  const filterProps = allFilters[entityTypeProps] || {};

  tableOptions = [
    recordOptionType.edit,
    recordOptionType.view,
    recordOptionType.clone,
    recordOptionType.delete,
  ];

  const filteringContextProviderRef = useRef(null);
  useEffect(() => {
    actions.getDefaultDataView(entityTypeProps);
    actions.initializeFiltering(entityTypeProps);
  }, []);

  useEffect(() => {
    const pageTitle = t('page.activity.overview.title');
    dispatch({
      pageTitle,
    });
  }, [dispatch]);

  const checkIfDataIsPresent = () => {
    const { possibleFieldsList, visibleFieldsList, visibleColumnsList } = filterProps;

    return (
      defaultFilteredList !== undefined &&
      possibleFieldsList !== undefined &&
      possibleFieldsList.length > 0 &&
      visibleFieldsList.length > 0 &&
      visibleColumnsList.length > 0 &&
      JSON.stringify(defaultFilteredList.result.entityType) === JSON.stringify(entityType.activity)
    );
  };

  return checkIfDataIsPresent() ? (
    <div className={styles.activityOverviewTable}>
      <Grid stackable>
        <FilteringContextProvider
          ref={filteringContextProviderRef}
          visibleColumns={filterProps.visibleColumnsList}
          visibleFields={filterProps.visibleFieldsList}
          actions={actions}
          entityType={entityTypeProps}
          filterProps={filterProps}
          tableOptions={tableOptions}
          defaultFilteredList={defaultFilteredList}
          selectedRows={{}}
        >
          <Grid.Row className={styles.activityGridRow}>
            <Grid.Column className="componentWithBottomMarginNoPadding">
              <AccordionWrapper
                titleClassName={'accordionHeaderCompact'}
                className="filterPanel"
                accordionTitle={t('filter.panel.title')}
                render={() => <FiltersPanel />}
              />
            </Grid.Column>
          </Grid.Row>

          <ViewOptionsContainer
            handleAddNewRecord={() => history.push(`${Activity.baseName}/create`)}
            isRenderExport
          />

          <Grid.Row className={styles.activityGridRow}>
            <Grid.Column className="componentWithBottomMarginNoPadding">
              <OverviewTable renderRecordsPerPage={false} />
            </Grid.Column>
          </Grid.Row>
        </FilteringContextProvider>
      </Grid>
    </div>
  ) : (
    <Loading isLoading />
  );
};

const mapStateToProps = (state: any) => ({
  allFilters: state.filter,
  entityTypeProps: entityType.activity,
  defaultFilteredList: state.dataView.defaultFilteredList,
});

const mapDispatchToProps = (dispatch: any) => ({
  actions: {
    initializeFiltering: (entityType: any) =>
      dispatch(filterActions.initializeFiltering(entityType)),
    applyFilterAction: (entityType: any, filterState: any, filters: any) =>
      dispatch(filterActions.applyFilterV2(entityType, filterState, filters)),
    getDefaultDataView: (entityType: any) => {
      dispatch(dataViewActions.getDefaultDataView(entityType, null, null));
    },
  },
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(ActivityOverviewContainer);
